"use client";

import { motion } from "framer-motion";
import { cn } from "@/lib/utils";
import { marketingMotion } from "@/lib/motion/config";

interface ISectionHeadingProps {
  heading: string;
  subtitle?: string;
  /** Render as h2 (default) or h3. */
  as?: "h2" | "h3";
  centered?: boolean;
  className?: string;
}

export function SectionHeading({
  heading,
  subtitle,
  as: Tag = "h2",
  centered = true,
  className,
}: ISectionHeadingProps): React.ReactElement {
  return (
    <motion.div
      className={cn(centered && "text-center", className)}
      initial={{ opacity: 0, y: 10 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={marketingMotion.viewport}
      transition={{ duration: marketingMotion.duration.base }}
    >
      <Tag
        className={cn(
          "font-bold tracking-tight text-foreground",
          Tag === "h2" && "text-3xl md:text-4xl",
          Tag === "h3" && "text-2xl md:text-3xl"
        )}
      >
        {heading}
      </Tag>
      {subtitle && (
        <p className="mx-auto mt-3 max-w-2xl text-lg text-muted-foreground">
          {subtitle}
        </p>
      )}
    </motion.div>
  );
}
